import { IMinerProfileEditorErrors } from "@mobx/store/minerProfiles/editor";

export const mapMinerProfileEditorErrors = (
  errors: IMinerProfileEditorErrors
): { [key: string]: boolean } => {
  const mappedErrors: { [key: string]: boolean } = {};

  if (errors.name) mappedErrors.name = true;
  if (errors.performance) mappedErrors.perfomance = true;
  if (errors.consumption) mappedErrors.consumpation = true;
  if (errors.width) mappedErrors.width = true;
  if (errors.height) mappedErrors.height = true;
  if (errors.depth) mappedErrors.depth = true;

  return mappedErrors;
};
